import React from "react";
import ScreeningQuestionOne from "../shared/ScreeningQuestionOne";
import { handleStoreAlreadyDoneDetails } from "../public/CommonAPIHelper";

const AlreadyDoneQuestionOneUI = () => {
  return (
    <ScreeningQuestionOne
      questionText="What is the most recent screening you had performed?"
      backRoute="../questions/1"
      nextRoute="/alreadydone/2"
      onSubmitHandler={handleStoreAlreadyDoneDetails}
    />
  );
};

export default AlreadyDoneQuestionOneUI;
